export enum CreatedAtParam {
    BEFORE = "before",
    STRICTLY_BEFORE = "strictly_before",
    AFTER = "after",
    STRICTLY_AFTER = "strictly_after",
}
